export default __webpack_public_path__ + "static/media/9-NikauMagic.b264aa1e.jpeg";